export enum TableColumnKey {
  HoverActions = 'hoverActions',
  Actions = 'actions',
  Index = 'index',
  Empty = 'empty',
}
